import {
  Input,
  Inject,
  OnInit,
  Directive,
  HostListener,
} from 'ng-metadata/core';

import { DialogService } from 'services/dialog.service';



/**
 * Triggers open a Material dialog for authentication
 */
@Directive({
  selector: '[gw-guarantee-open]',
})
export class GuaranteeOpenDirective {

  constructor(
    @Inject(DialogService) private dialogService: DialogService,
  ) {}

  @HostListener('click', ['$event'])
  onClick($event) {
    const dialog = this.dialogService.openHappyGuarantee({}, $event);
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/directives/guarantee-open.directive.ts